import { lazy, Suspense } from 'react'

import type { RouteObject } from 'react-router'

import { PageLayoutSkeleton } from '@/layouts/page'

import { ConsultaLeadsRepresadosPageSkeleton } from '../pages/consulta-leads-represados/skeleton'
import { DetalhesLeadRepresadoPageSkeleton } from '../pages/detalhes-lead-represado/skeleton'
import { EnvioDocumentosLeadsPage } from '../pages/envio-documentos'

const ConsultaLeadsRepresadosPage = lazy(() =>
  import('../pages/consulta-leads-represados').then((module) => ({ default: module.ConsultaLeadsRepresadosPage })),
)

const CadastroLeadRepresadoPage = lazy(() =>
  import('../pages/cadastro-lead-represado').then((module) => ({ default: module.CadastroLeadRepresadoPage })),
)

const DetalhesLeadRepresadoPage = lazy(() =>
  import('../pages/detalhes-lead-represado').then((module) => ({ default: module.DetalhesLeadRepresadoPage })),
)

export const brasilLeadsRepresadoRoutes: RouteObject[] = [
  {
    path: 'leads-represados',
    children: [
      {
        index: true,
        element: (
          <Suspense
            fallback={
              <PageLayoutSkeleton>
                <ConsultaLeadsRepresadosPageSkeleton />
              </PageLayoutSkeleton>
            }
          >
            <ConsultaLeadsRepresadosPage />
          </Suspense>
        ),
      },
      {
        path: 'cadastrar',
        element: <CadastroLeadRepresadoPage />,
      },
      {
        path: ':id',
        element: (
          <Suspense
            fallback={
              <PageLayoutSkeleton>
                <DetalhesLeadRepresadoPageSkeleton />
              </PageLayoutSkeleton>
            }
          >
            <DetalhesLeadRepresadoPage />
          </Suspense>
        ),
      },
      {
        path: ':id/enviar-documentos',
        element: <EnvioDocumentosLeadsPage />,
      },
    ],
  },
]
